<div class="lightbox" *ngIf="lightboxState.isOpen" id="lightbox" (touchstart)="handleTouchStart($event)"
  (touchmove)="handleTouchMove($event)" (touchend)="handleTouchEnd()">
  <div (click)="downloadMedia()" *ngIf="showDownloadButton" class="download-area">
    <span class="icon download-img"></span>
  </div>
  <div (click)="closeLightbox()" id="close-btn">
    <span class="icon icon_close"></span>
  </div>
  <div class="index-display">{{ lightboxState.currentIndex + 1 }}/{{ lightboxState.items.length }}</div>
  <div class="lightbox-content">
    <div *ngIf="isMediaLoading" class="spinner-container">
      <wb-spinner></wb-spinner>
    </div>
    <ng-container *ngIf="lightboxState.items[lightboxState.currentIndex]?.type === 'IMAGE' || lightboxState.items[lightboxState.currentIndex]?.type === 'PHOTOSPOT'; else videoContainer">
      <img #imageElement [class.hidden]="isMediaLoading" [src]="lightboxState.items[lightboxState.currentIndex]?.url" alt="lightbox-content" (load)="onLoad()"
        (error)="onError()">
    </ng-container>
    <ng-template #videoContainer>
      <app-custom-video [class.hidden]="isMediaLoading" (videoLoaded)="onVideoLoaded()" #customVideo [sourceUrl]="lightboxState.items[lightboxState.currentIndex]?.url" [thumbnail_url]="lightboxState.items[lightboxState.currentIndex]?.thumbnail_url"></app-custom-video>
    </ng-template>
  </div>
  <div class="button-sec">
    <button class="arrow-button left" (click)="prevItem()" [ngClass]="{ disabled: lightboxState.currentIndex == 0 }" [attr.disabled]="lightboxState.currentIndex == 0 ? true : null"></button>
    <button class="arrow-button right" (click)="nextItem()" [ngClass]="{ disabled: lightboxState.currentIndex == lightboxState.items.length - 1 }" [attr.disabled]="lightboxState.currentIndex == lightboxState.items.length - 1 ? true : null"></button>
  </div>
